import { BaseRequest } from './../../../data/shared/base.request';
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base/use-case";
import { GetGridHeadersRequest, GridHeader } from "../../domain";
import { GridHeadersRepository } from "../../repositories";

@Injectable({ providedIn: 'root' })
export class GetGridHeadersUsecase implements UseCase<BaseRequest<GetGridHeadersRequest>, GridHeader[]> {

  constructor(private gridHeadersRepository: GridHeadersRepository) {
  }

  execute(params: BaseRequest<GetGridHeadersRequest>): Observable<GridHeader[]> {
    return this.gridHeadersRepository.getGridHeaders(params);
  }

}
